<template>
<div>
</div>
</template>

<script>
import { useClient, useMutation } from 'villus';
import { gql } from 'graphql-tag';
import { computed, reactive } from 'vue';
import { useStore } from 'vuex';

export default {
  name: 'updateUserDataWrongPlayedQuestionsMutation',

  setup() {
    const store = useStore();

    useClient({
      url: process.env.VUE_APP_STRAPI,
    });

    const updateUserDataWrongPlayedQuestionsMutation = gql`
      mutation($id: ID!, $wrongPlayedQuestions: JSON!) {
        updateUserData(id: $id, data: { wrongPlayedQuestions: $wrongPlayedQuestions }) {
          data {
            id
          }
        }
      }
      `;

    const context = reactive({
      headers: computed(() => store.state.auth.headers),
    });

    const { execute: updateUserDataWrongPlayedQuestions } = useMutation(updateUserDataWrongPlayedQuestionsMutation, {
      context,
    });

    store.commit('setStrapiExecutionHandler', { item: 'updateUserDataWrongPlayedQuestions', result: updateUserDataWrongPlayedQuestions });
  },
};
</script>
